import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-navbar',
  standalone: true, imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    RouterLink,
    MatMenuModule
  ],
  templateUrl: './navbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./navbar.component.css'],
})
export class NavbarComponent implements OnInit {
  appTitle = 'Catena-X';
  environmentSuffix = '';
  userRole: string | string[] | null = null;
  routes: any[] = [];

  visualisationRoutes = [{
    name: "Shell Management",
    roles: [environment.adminsRoleName],
    children: [{
      path: "/shells/part-instances",
      name: "Part Instances"
    },
    {
      path: "/shells/catalog-parts",
      name: "Catalog Parts"
    }]
  }]

  developerRoutes = [
    {
      path: "/asset-transfer/post-requests",
      name: "Unique ID Push",
      roles: [environment.adminsRoleName]
    }
  ]

  adminRoutes = [
    {
      name: "Admin",
      roles: [environment.adminsRoleName],
      children: [{
        path: "/edc-resources/edc-list",
        name: "EDR Management"
      },
      {
        path: "/edc-resources/cluster-management",
        name: "Cluster Management"
      }]
    }]

  qualityRoutes = [
    {
      name: "Quality",
      roles: [environment.salesUsersRoleName, environment.adminsRoleName],
      children: [{
        path: "/quality/part-requests",
        name: "Part Requests"
      }]
    }
  ];

  constructor(private router: Router, private authService: AuthService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    // Set environment suffix for display in the navbar
    if (environment.stage && environment.stage !== 'prod') {
      this.environmentSuffix = ` (${environment.stage.toUpperCase()})`;
    }

    // Load user role and populate routes
    this.authService.getUserRole().subscribe((role) => {
      this.userRole = role;
      this.populateRoutes();
      this.cdr.markForCheck();
    });
  }

  private populateRoutes(): void {
    this.routes = [];

    // CATENA_ADMINS see everything (visualization, developer, admin, sales)
    if (this.isAdmin()) {
      this.routes.push(...this.visualisationRoutes);
      this.routes.push(...this.developerRoutes);
      this.routes.push(...this.adminRoutes);
      this.routes.push(...this.qualityRoutes);
    }
    // SALES_USERS see quality routes only
    else if (this.isSalesUser()) {
      this.routes.push(...this.qualityRoutes);
      this.router.navigate(['/secure/quality/part-requests']);
    }

    this.cdr.markForCheck();
  }

  private isAdmin(): boolean {
    if (Array.isArray(this.userRole)) {
      return this.userRole.includes(environment.adminsRoleName);
    }
    return this.userRole === environment.adminsRoleName;
  }

  private isSalesUser(): boolean {
    if (Array.isArray(this.userRole)) {
      return this.userRole.includes(environment.salesUsersRoleName);
    }
    return this.userRole === environment.salesUsersRoleName;
  }

  logout() {
    this.authService.signOut();
  }
}
